import { types as t } from 'mobx-state-tree'
import { Point } from '../../lib/types'

export const DatumModel = t.model('DatumModel', {
  country_code: t.string,
  region_name: t.string,
  sub_region_name: t.string,
  country: t.string,
  year: t.number,
  pop_total: t.number,
  gdp: t.union(t.string, t.number),
  loc_id: t.number,
  agriculture: t.union(t.string, t.number),
  buildings: t.union(t.string, t.number),
  manufacturing: t.union(t.string, t.number),
  electricity: t.union(t.string, t.number),
  transport: t.union(t.string, t.number),
  agriculture_imputed: t.boolean,
  buildings_imputed: t.boolean,
  manufacturing_imputed: t.boolean,
  electricity_imputed: t.boolean,
  transport_imputed: t.boolean,
})
export type Datum = typeof DatumModel.Type

export type ChallengeColumnName =
  | 'agriculture'
  | 'manufacturing'
  | 'buildings'
  | 'electricity'
  | 'transport'

export type ChallengesMap<T> = {
  [K in ChallengeColumnName]: T
}

export type ChallengeInfo = {
  isActive: boolean
  name: string
  value?: number
}

export type GeoFilter = { name: string; isActive: boolean }

export enum ScaleType {
  LINEAR = 'linear',
  SYMLOG = 'symlog',
}
export type MinMax = { min: number; max: number }
export type ScaleInfo = {
  [scaleType in ScaleType]: {
    function: any // ScaleSymLog<number, number> | ScaleLinear<number, number>
    ariosity: { x: MinMax; y: MinMax }
  }
}

export type NumericDomain = [number, number]
export type NumericRange = [number, number]
export type DatumWithCoords = Datum & Point
export type Path = { country: string; pathPoints: DatumWithCoords[] }
export type AriosityDirection = 'min' | 'max' | 'both'
